<div class="h-full">
  <div
    class="w-full h-[48px] leading-[48px] font-medium text-sm text-color-primary uppercase text-center border-b-[2px] border-color-color-primary border-solid border-r-0 border-l-0 border-t-0"
  >
    {{ 'NOTIFICATIONS.TITLE' | translate }}
  </div>

  <div class="py-[10px] h-[calc(100%_-_97px)]">
    <ng-scrollbar>
      <div class="px-[10px] w-full flex justify-between items-center">
        <p class="text-sm m-0">
          {{ 'NOTIFICATIONS.ALL_NOTIFICATIONS' | translate }}
        </p>

        <button
          type="button"
          mat-icon-button
          [matTooltip]="'NOTIFICATIONS.MARK_ALL_AS_READ' | translate"
          [matTooltipPosition]="'left'"
          (click)="markAllNotificationsAsRead()"
        >
          <mat-icon>done_all</mat-icon>
        </button>
      </div>

      @for (notification of notifications; track $index) {
        <div (click)="openNotification(notification)" class="p-2 min-h-14 flex items-center justify-between cursor-pointer" matRipple>
          <div class="flex gap-[20px] items-center">
            <div class="relative">
              <img
                [title]="notification.data?.author?.name"
                [src]="notification.data?.author?.avatarUrl || 'https://ui-avatars.com/api/?name=' + notification.data?.author?.name"
                alt="user image"
                class="w-[45px] h-[45px] min-w-[45px] max-w-[45px] min-h-[45px] max-h-[45px] object-cover rounded-full bg-color-light-shade shadow-md"
              />
              <div
                class="w-[20px] h-[20px] rounded-full flex items-center justify-center absolute top-[30px] left-[30px] shadow-md"
                [ngClass]="notification.toolbar.class"
              >
                @if (!notification.toolbar.isSvg) {
                  <mat-icon
                    class="grid place-content-center w-[16px] h-[16px] text-[16px]"
                    [ngClass]="notification?.toolbar?.textClass || 'text-white'"
                  >
                    {{ notification.toolbar.icon }}
                  </mat-icon>
                }
                @if (notification.toolbar.isSvg) {
                  <mat-icon
                    class="grid place-content-center w-[16px] h-[16px] text-[16px]"
                    [svgIcon]="notification.toolbar.icon"
                    [ngClass]="notification?.toolbar?.textClass || 'text-white'"
                  ></mat-icon>
                }
              </div>
            </div>
            <div class="flex flex-col h-full gap-1">
              <p class="text-sm text-color-text m-0 max-w-[370px] break-all" [class.font-medium]="!notification.readAt">
                {{ notification.title }}
              </p>
              <p class="text-sm text-color-secondary m-0">
                {{ notification.createdAt | fromNow }}
              </p>
            </div>
          </div>
          @if (!notification.readAt) {
            <button
              type="button"
              mat-icon-button
              [disableRipple]="true"
              class="text-[#e67700]"
              [matTooltip]="'NOTIFICATIONS.MARK_AS_READ' | translate"
              [matTooltipPosition]="'left'"
              (click)="markNotificationAsRead(notification, $event)"
            >
              <mat-icon>check</mat-icon>
            </button>
          }
        </div>
      }

      @if (isLoadingNotifications) {
        @for (fakeNotification of [].constructor(20); track $index) {
          <div>
            <div class="p-[10px] flex items-center justify-between cursor-pointer">
              <div class="flex gap-[20px] items-center">
                <div class="relative">
                  <ngx-skeleton-loader
                    appearance="circle"
                    [theme]="{ width: '45px', height: '45px', margin: '0' }"
                  ></ngx-skeleton-loader>
                </div>
                <div class="flex flex-col">
                  <ngx-skeleton-loader
                    appearance="line"
                    [theme]="{ width: '405px', height: '14px', margin: '0' }"
                  ></ngx-skeleton-loader>
                  <ngx-skeleton-loader
                    appearance="line"
                    [theme]="{ width: '100px', height: '14px', margin: '0' }"
                  ></ngx-skeleton-loader>
                </div>
              </div>
            </div>
          </div>
        }
      }
    </ng-scrollbar>
  </div>

  <div class="border-t-[thin] border-color-light-shade border-solid border-r-0 border-l-0 border-b-0 h-[48px] flex">
    <a
      mat-button
      class="w-full h-full font-medium text-sm text-color-primary rounded-none no-underline"
      [disabled]="isLoadingNotifications"
      (click)="openNotificationCenter()"
      mat-dialog-close
    >
      {{ 'NOTIFICATIONS.GO_TO_NOTIFICATION_CENTER' | translate }}
    </a>
  </div>
</div>
